// extracted by mini-css-extract-plugin
export default {"layout":"DuQ3_c","content":"trh76H","detailsAndPhoto":"i51zb6","memberDetails":"Qc8mez","blocked":"duoFWS","container":"vur9Pk","isOnlyNameVisible":"D8IRlQ"};